import type {
  OverviewDrillParams,
  OverviewEntity,
  OverviewQuery,
  OverviewView,
} from '@/services/bff/crm-overview.api';
export const overviewResources = {
  customer: 'customers',
  contact: 'contacts',
  lead: 'leads',
  opportunity: 'opportunities',
} as const;
export const overviewViewLabels: Record<OverviewView, string> = {
  my: '我负责的',
  team: '我下属的',
  collab: '我协作的',
  pool: '公海',
  all: '全部可访问',
  followed: '我关注的',
  imported: '导入记录',
};
export function availableOverviewViews(
  entity: OverviewEntity,
  access: Record<string, boolean>,
): OverviewView[] {
  const views: OverviewView[] = ['my', 'team', 'collab', 'pool', 'all'];
  if (entity === 'contact') views.splice(views.indexOf('pool'), 1);
  if (entity === 'opportunity') views.splice(1, 0, 'followed');
  if (entity === 'lead') views.push('imported');
  return views.filter((view) =>
    Boolean(access[`${overviewResources[entity]}-${view}`]),
  );
}
export function getOverviewDrillParams(search?: string): OverviewDrillParams {
  const values = new URLSearchParams(search || '');
  if (!values.has('overviewMetric') && !values.has('overviewDimension'))
    return {};
  const result: Record<string, string> = {};
  for (const key of [
    'overviewMetric',
    'overviewDimension',
    'overviewValue',
    'overviewStartDate',
    'overviewEndDate',
    'overviewForecastGrouping',
    'ownerUserUuid',
    'customerUuid',
  ])
    if (values.has(key)) result[key] = values.get(key) || '';
  return result;
}
export function overviewListPath(
  entity: OverviewEntity,
  query: OverviewQuery,
  period: { startDate: string; endDate: string },
  filter: OverviewDrillParams = {},
): string {
  const params = new URLSearchParams({
    overviewMetric: 'total',
    overviewStartDate: period.startDate,
    overviewEndDate: period.endDate,
  });
  const source = new URLSearchParams({
    viewMode: query.viewMode,
    period: query.period,
  });
  if (query.startDate) source.set('startDate', query.startDate);
  if (query.endDate) source.set('endDate', query.endDate);
  if (query.forecastGrouping) {
    params.set('overviewForecastGrouping', query.forecastGrouping);
    source.set('forecastGrouping', query.forecastGrouping);
  }
  if (query.ownerUserUuid) {
    params.set('ownerUserUuid', query.ownerUserUuid);
    source.set('ownerUserUuid', query.ownerUserUuid);
  }
  params.set('overviewSource', `/${entity}/overview?${source.toString()}`);
  for (const [key, value] of Object.entries(filter))
    if (value !== undefined) params.set(key, value);
  return `/${entity}/${query.viewMode}?${params.toString()}`;
}
